<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form
        :inline="true"
        size="small"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="进出口管理名称">
          <el-input
            placeholder="请输入进出口管理名称"
            v-model="formInline.search"
          >
          </el-input>
        </el-form-item>
        
        <el-form-item label="所属分类">
          <el-select
            v-model="formInline.category"
            placeholder="请选择分类"
            clearable
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="国家宣传" :value="0"></el-option>
            <el-option label="物流板块" :value="1"></el-option>
            <el-option label="金融" :value="2"></el-option>
            <el-option label="报关" :value="3"></el-option>
            <el-option label="商旅考察" :value="4"></el-option>
            <el-option label="进出口产品" :value="5"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="审核状态">
          <el-select
            v-model="formInline.status"
            placeholder="请选择审核状态"
            clearable
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="审核通过" :value="1"></el-option>
            <el-option label="审核拒绝" :value="2"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button
        size="small"
        icon="el-icon-plus"
        type="primary"
        @click="addClick"
        >添加进出口管理</el-button
      >
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column
              prop="enterprise.name"
              label="企业名称"
            ></el-table-column>
            <el-table-column label="图片">
              <template slot-scope="scope">
                <img
                  v-if="scope.row.image && scope.row.image.length > 0"
                  :src="scope.row.image[0].file_path"
                  alt="图片"
                  style="width: 100px; height: auto;"
                />
              </template>
            </el-table-column>
            <!-- <el-table-column prop="intro" label="详情"></el-table-column> -->
            <el-table-column
              prop="charge_name"
              label="负责人姓名"
            ></el-table-column>
            <el-table-column
              prop="charge_phone"
              label="负责人电话"
            ></el-table-column>
            <el-table-column prop="category" label="所属分类">
              <template slot-scope="scope">
                {{
                  {
                    0: "国家宣传",
                    1: "物流板块",
                    2: "金融",
                    3: "报关",
                    4: "商旅考察",
                    5: "进出口产品"
                  }[scope.row.category] || scope.row.category
                }}
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="status" label="审核状态" width="100">
              <template slot-scope="scope">
                <el-tag
                  :type="statusType[scope.row.status]"
                  size="small"
                >
                  {{ statusText[scope.row.status] }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="150"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  @click="editClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  v-if="scope.row.status === 0"
                  @click="auditClick(scope.row, 1)"
                  type="text"
                  size="small"
                  style="color: #67C23A;"
                  class="member-btn"
                  >通过
                   <span v-if="scope.row.is_read == 0" class="unread-dot-member"></span>
                  </el-button
                >
                <el-button
                  v-if="scope.row.status === 0"
                  @click="auditClick(scope.row, 2)"
                  type="text"
                  size="small"
                  style="color: #F56C6C;"
                  >拒绝</el-button
                >
                <el-button
                  v-if="scope.row.status !== 0"
                  @click="resetAuditClick(scope.row)"
                  type="text"
                  size="small"
                  style="color: #E6A23C;"
                  >重置审核</el-button
                >
                <el-button
                  @click="deleteClick(scope.row)"
                  type="text"
                  size="small"
                  style="color: #F56C6C;"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!-- 审核对话框 -->
    <el-dialog
      :title="auditDialogTitle"
      :visible.sync="auditDialogVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form :model="auditForm" label-width="80px">
        <el-form-item label="审核操作">
          <el-radio-group v-model="auditForm.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核备注" v-if="auditForm.status === 2">
          <el-input
            type="textarea"
            v-model="auditForm.remark"
            placeholder="请输入拒绝原因（可选）"
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="auditDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAudit">确定</el-button>
      </div>
    </el-dialog>

    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit
      :open_add="open_edit"
      :import_export_manage_id="import_export_manage_id"
      v-if="open_edit"
      @close="closeEdit"
    ></Edit>

    <el-dialog
      style="text-align: center"
      title="设置标题"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
    </el-dialog>
  </div>
</template>

<script>
import Import_export_manageApi from "@/api/import_export_manage.js";
import Add from "./part/add.vue";
import Edit from "./part/edit.vue";
  import SupplyApi from '@/api/supply.js';

export default {
  components: {
    Add,
    Edit
  },
  inject: ["reload"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: "",
        category: "", // 添加分类筛选字段
        status: "" // 添加审核状态筛选字段
      },

      open_add: false,
      open_edit: false,
      import_export_manage_id: "",
      dialogVisible: false,

      // 审核相关
      auditDialogVisible: false,
      auditDialogTitle: "审核操作",
      auditForm: {
        import_export_manage_id: "",
        status: 1,
        remark: ""
      },

      // 状态映射
      statusText: {
        0: "待审核",
        1: "审核通过",
        2: "审核拒绝"
      },
      statusType: {
        0: "warning",
        1: "success",
        2: "danger"
      }
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },

  methods: {
    /* 重置搜索条件 */
    resetSearch() {
      this.formInline = {
        search: "",
        category: "",
        status: ""
      };
      this.curPage = 1;
      this.getTableList();
    },
    
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    setting(e) {
      //进出口管理标题设置
      this.dialogVisible = true;
    },
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.curPage = 1; // 搜索时重置到第一页
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = { ...this.formInline }; // 使用扩展运算符创建新对象
      
      // 过滤空值参数
      Object.keys(Params).forEach(key => {
        if (Params[key] === '' || Params[key] === null || Params[key] === undefined) {
          delete Params[key];
        }
      });
      
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      
      Import_export_manageApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.import_export_manage_id = row.import_export_manage_id;
      this.open_edit = true;
    },

    /*审核操作*/
    auditClick(row, status) {
      this.auditForm = {
        import_export_manage_id: row.import_export_manage_id,
        status: status,
        remark: ""
      };
      
      if (status === 1) {
        // 直接通过
        this.confirmAudit();
      } else {
        // 拒绝时显示对话框输入原因
        this.auditDialogTitle = "审核拒绝";
        this.auditDialogVisible = true;
      }
    },

    /*重置审核状态*/
    resetAuditClick(row) {
      let self = this;
      self.$confirm("确定要重置审核状态吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        Import_export_manageApi.audit({
          import_export_manage_id: row.import_export_manage_id,
          status: 0
        }, true)
        .then(data => {
          if (data.code == 1) {
            self.$message.success("重置审核状态成功");
            self.getTableList();
          } else {
            self.$message.error(data.msg || "操作失败");
          }
        })
        .catch(error => {
          self.$message.error("操作失败");
        });
      }).catch(() => {});
    },

    /*确认审核*/
    confirmAudit() {
      let self = this;
      let statusText = self.auditForm.status === 1 ? "通过" : "拒绝";
      
      self.$confirm(`确定要${statusText}该记录吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        Import_export_manageApi.audit(self.auditForm, true)
          .then(data => {
            if (data.code == 1) {
              self.$message.success(`审核${statusText}成功`);
              self.auditDialogVisible = false;
              self.getTableList();
            } else {
              self.$message.error(data.msg || `审核${statusText}失败`);
            }
          })
          .catch(error => {
            self.$message.error(`审核${statusText}失败`);
          });
      }).catch(() => {});
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          Import_export_manageApi.del(
            {
              import_export_manage_id: row.import_export_manage_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.getTableList();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style>
/* 可以添加一些样式优化 */
.common-seach-wrap .el-form-item {
  margin-bottom: 0;
}
 /* 可以根据需要添加样式 */
  .member-btn {
  position: relative;
}

/* 会员未读红点样式 */
.unread-dot-member {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background-color: #ff4757;
  border-radius: 50%;
  animation: pulse 2s infinite;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/import_export_manage/index/index.vue